import { defineMessages } from 'react-intl';

export default defineMessages({
    standardizingAddressMessage: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.Standardizing address...',
        defaultMessage: 'Standardizing address...'
    },
    loadingNextPageMessage: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.Loading next page...',
        defaultMessage: 'Loading next page...'
    },
    creatingYourSubmissionMessage: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.Creating your submission...',
        defaultMessage: 'Creating your submission...'
    },
    ehPriorAddressTitle: {
        id: 'quoteandbind.eh.views.eh-priorAddress-details.priorAddress',
        defaultMessage: 'Prior Address'
    },
    ehPriorAddressTitleNumber: {
        id: 'quoteandbind.eh.views.eh-priorAddress-details.priorAddress Number:',
        defaultMessage: 'Prior Address:'
    },
    ehPriorAddress: {
        id: 'quoteandbind.eh.quote.Homeowners priorAddress',
        defaultMessage: 'Prior Address'
    },
    removePriorAddressTitle: {
        id: 'quoteandbind.eh.controllers.EHpriorAddressDetailsCtrl.Remove priorAddress?',
        defaultMessage: 'Remove Prior Address?'
    },
    removePriorAddressDescription: {
        id: 'quoteandbind.eh.drivers.remove-priorAddress.message',
        defaultMessage: 'Are you sure you want to remove this Prior Address from the list of Prior Addresses?'
    },
    ehAddAnotherPriorAddressTitle: {
        id: 'quoteandbind.eh.views.eh-priorAddress-details.Add Another priorAddress?',
        defaultMessage: 'Add Another Prior Address?'
    },
    ehAddPriorAddressButtonText: {
        id: 'quoteandbind.eh.views.eh-priorAddress-details.Add priorAddress',
        defaultMessage: 'Add Prior Address'
    },
    ehPriorAddressToggleButton: {
        id: 'quoteandbind.eh.views.eh-priorAddress-details.Lived one Year',
        defaultMessage: 'Lived there more than one year?'
    },
    ehAddAnotherPriorAddress: {
        id: 'quoteandbind.eh.views.eh-priorAddress-details.Add another address',
        defaultMessage: 'Add Prior Address'
    },
    ehOptional: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.optional',
        defaultMessage: 'Optional'
    },
    ehAgencyInformation: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.Agency Information',
        defaultMessage: 'Agency Information'
    },
    newHomePurchase: {
        id: 'quoteandbind.eh.quick.views.policyDetails.New Home Purchase',
        defaultMessage: 'Is this quote for a new home purchase?'
    },
    newHomePurchaseYes: {
        id: 'quoteandbind.eh.quick.views.policyDetails.New Home Purchase.Yes',
        defaultMessage: 'Yes'
    },
    newHomePurchaseNo: {
        id: 'quoteandbind.eh.quick.views.policyDetails.New Home Purchase.No',
        defaultMessage: 'No'
    },
    currentInsuranceForProperty: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Do you Currently have insurance on this Property?',
        defaultMessage: 'Do you Currently have insurance on this Property?'
    },
    currentInsuranceForPropertyYes: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Do you Currently have insurance on this Property?.Yes',
        defaultMessage: 'Yes'
    },
    currentInsuranceForPropertyNo: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Do you Currently have insurance on this Property?.No',
        defaultMessage: 'No'
    },
    lastPolicyExpiration: {
        id: 'quoteandbind.eh.quick.views.policyDetails.When did your last Policy Expire?',
        defaultMessage: 'When does your current policy expire/When did your last policy expire?'
    },
    currentInsuranceExpire: {
        id: 'quoteandbind.eh.quick.views.policyDetails.When does your current insurance expire?',
        defaultMessage: 'When does your current insurance expire?'
    },
    insuranceHistory: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Insurance History',
        defaultMessage: 'Insurance History'
    },
    losses: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Losses',
        defaultMessage: 'Losses'
    },
    propertyLossesLabel: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Have you had any Property Losses in the Past 5 year?',
        defaultMessage: 'Have you had any Property Losses in the Past 5 year?'
    },
    propertyLossesYes: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Have you had any Property Losses in the Past 5 year?.Yes',
        defaultMessage: 'Yes'
    },
    propertyLossesNo: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Have you had any Property Losses in the Past 5 year?.No',
        defaultMessage: 'No'
    },
    manualPropertyLossesAdd: {
        id: 'quoteandbind.eh.views.Policy Details.Manual Property Losses.Add Property Losses',
        defaultMessage: 'Add Property Losses'
    },
    accountTypeErrorMessage: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Account type must be a Company or a Person',
        defaultMessage: 'Account type must be a Company or a Person'
    },
    newAccountCreateErrorMessage: {
        id: 'quoteandbind.eh.quick.views.policyDetails.Could not create the Account',
        defaultMessage: 'Could not create the Account'
    },
    effectiveDate: {
        id: 'quoteandbind.eh.views.eh-policy-info.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'quoteandbind.eh.views.eh-policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    rateAsOfDate: {
        id: 'quoteandbind.eh.views.eh-policy-info.Rate as of Date',
        defaultMessage: 'Rate as of Date'
    },
    riskState: {
        id: 'quoteandbind.eh.views.eh-policy-info.Risk State',
        defaultMessage: 'Risk State'
    },
    middleName: {
        id: 'quoteandbind.eh.views.eh-policy-info.M.I.',
        defaultMessage: 'M.I.'
    },
    zipCode: {
        id: 'quoteandbind.eh.views.eh-policy-info.Zip Code',
        defaultMessage: 'Zip Code'
    },
    sourceOfEntry: {
        id: 'quoteandbind.eh.views.ea-policydetails-details.Source of Entry',
        defaultMessage: 'Source of Entry'
    },
    policyForm: {
        id: 'quoteandbind.eh.views.eh-policy-info.Policy Form',
        defaultMessage: 'Policy Form'
    },
    policyInformation: {
        id: 'quoteandbind.eh.views.eh-policy-info.Policy Information',
        defaultMessage: 'Policy Information'
    },
    lastName: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.Last Name',
        defaultMessage: 'Last Name'
    },
    email: {
        id: 'quoteandbind.eh.views.eh-policydetails-details.Email',
        defaultMessage: 'Email'
    },
    newPurchaseWithin180Days: {
        id: 'quoteandbind.eh.quick.views.policyDetails.New purchase within 180 days',
        defaultMessage: 'New purchase within 180 days'
    },
    selfDeclaredPropertyLossesTitle: {
        id: 'quoteandbind.eh.quick.views.insuredPage.Self Declared Property Losses',
        defaultMessage: 'Self Declared Property Losses'
    },
    locationCodeHelpText: {
        id: 'quoteandbind.eh.quick.views.mailingAndBillingAddress.Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.',
        defaultMessage: 'Location Code(s) available. Contact MSA at FOSCLicensing@MSAGROUP.COM to request updates.'
    }
});
